module.exports = __webpack_public_path__ + "img/mfence_app.97a107a2.svg";